import { render, staticRenderFns } from "./CustomerChargeForm.vue?vue&type=template&id=647d0c95"
import script from "./CustomerChargeForm.vue?vue&type=script&lang=js"
export * from "./CustomerChargeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports